import React from "react";

// Dependencies
import ProdigioTheme from "prodigio-themes";

// Assets
import logo from "static/colegiolider/logo.svg";
import logoSmall from "static/colegiolider/logoSmall.svg";
import logoWhite from "static/colegiolider/logoWhite.svg";

// Navigation Icons
import SimuladoIcon from "prodigio-icons/web/outlined/Simulado";
import LiveIcon from "prodigio-icons/web/outlined/LiveClass";
import ProjectIcon from "prodigio-icons/web/outlined/Project";
import PreviousExamsIcon from "prodigio-icons/web/outlined/ProvasAnteriores";
import StudyPlanIcon from "prodigio-icons/web/outlined/StudyPlan";
import SubjectIcon from "prodigio-icons/web/outlined/Subject";
import FileIcon from "prodigio-icons/web/outlined/Apoio";
import QRCode from "prodigio-icons/web/outlined/QrCode";
import CustomExerciseListIcon from "prodigio-icons/web/outlined/CustomExerciseList";

// Helpers
import { INavigation } from "interfaces/INavigation";
import { generateThemeData } from "helpers/generate-theme-data";

export const prodigioTheme = new ProdigioTheme({
    project: {
        appUrl: "colegiolider.prodigioeducacao.com",
        brand: "proraiz",
        name: "Colegio Líder",
        slug: "proraiz",
        url: "colegiolider.prodigioeducacao.com",
        logo,
        logoSmall,
        logoWhite
    },
    mainColors: {
        base: "#83899E",
        brand: "#1B355D",
        secondary: "#EBEDF5"
    }
});

export const theme = generateThemeData(prodigioTheme, {
    brand: {
        100: "#abb0bf",
        200: "#7d8499",
        300: "#1b355d",
        400: "#15294b",
        500: "#101e39"
    },
    secondary: {
        100: "#f3f6fc",
        200: "#f0f3fa",
        300: "#ebedf5",
        400: "#e1e3eb",
        500: "#d8dae2"
    }
});

export const menuColors: any = {};

export const navigation: INavigation[] = [
    {
        name: "Plano de estudos",
        url: "/app/plano-de-estudos",
        icon: <StudyPlanIcon width="22" height="22" />,
        iconSecondary: <LiveIcon width="22" height="22" />
    },
    {
        name: "Matérias",
        url: "/app/materias",
        icon: <SubjectIcon width="22" height="22" />
    },
    {
        name: "Simulados",
        url: "/app/simulados",
        icon: <SimuladoIcon width="22" height="22" />
    },
    {
        name: "Banco de questões",
        url: "/app/banco-de-questoes",
        icon: <CustomExerciseListIcon width="22" height="22" />
    },
    {
        name: "Projetos",
        url: "/app/projetos",
        icon: <ProjectIcon width="22" height="22" />
    },
    {
        name: "Provas anteriores",
        url: "/app/provas-anteriores",
        icon: <PreviousExamsIcon width="22" height="22" />
    },
    {
        name: "Arquivos",
        url: "/app/arquivos",
        icon: <FileIcon width="22" height="22" />
    },
    {
        name: "QRCode",
        url: "/app/qr-code",
        icon: <QRCode width="22" height="22" />
    }
];
